module.exports = __webpack_public_path__ + "img/mylogo.ee3bfff3.png";